import { Grid } from '@mui/material'
import React from 'react'
import PrimaryButton from '../../../components/buttons'
import ModalLayout from '../../../components/modalLayout'

const DeleteConfirm = ({ isModalOpen, handleModal, setIsModalOpen, title, action }) => {
    return (
        <>
            {
                isModalOpen
                    ?
                    <ModalLayout
                        open={true}
                        handleClose={() => setIsModalOpen(null)}
                        title={"Delete"}
                    >
                        Do you want to Delete this {title} ?
                        <br />
                        <br />
                        <br />
                        <Grid container justifyContent={"space-between"}>
                            <Grid item md={6}>
                                <PrimaryButton
                                    buttonText="Yes"
                                    backgroundColor="#005ca8"
                                    width="100px"
                                    onClick={() => handleModal(isModalOpen, setIsModalOpen)}
                                />
                            </Grid>
                            <Grid item md={6}>
                                <PrimaryButton
                                    buttonText="No"
                                    backgroundColor="#ff0000"
                                    width="100px"
                                    float={'right'}
                                    onClick={() => setIsModalOpen(null)}

                                />
                            </Grid>
                        </Grid>
                    </ModalLayout>
                    : null
            }

        </>
    )
}

export default DeleteConfirm